module.exports = __webpack_public_path__ + "img/lunch_title--forbid.366139f7.png";